import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ContextDataProvider } from "./v2/contexts/ContextDataProvider";
import { ChatProvider } from "./v2/contexts/ChatContext";
import ErrorPage from "./components/ErrorPage";
import Inventory from "./views/demo/Inventory";
import Details from "./views/demo/Details";

const ChatBox = lazy(() => import("./components/Chat/ChatBox"));
const TextMeView = lazy(() => import("./views/TextMe"));
const Popup = lazy(() => import("./components/Popup/Popup"));
const ChatLayout = lazy(() => import("./v2/components/Chat/ChatLayout"));
const CtaView = lazy(() => import("./views/CtaView"));
const MobileCoupon = lazy(() => import("./views/MobileCoupon"));
const DesktopCoupon = lazy(() => import("./views/DesktopCoupon"));
const MobileCta = lazy(() => import("./views/MobileCta"));
const SubscriberGrowth = lazy(() => import("./views/SubscriberGrowth"));
const WizLayout = lazy(() => import("./v2/components/Chat/Wiz/WizLayout"));

function App() {
  return (
    <ContextDataProvider>
      <Router>
        <Suspense fallback={<div></div>}>
          <Routes>
            <Route path="/coupon/:token/:lang" element={<MobileCoupon />} />
            <Route
              path="/mobile-coupon/:token/:lang"
              element={<MobileCoupon />}
            />
            <Route
              path="/desktop-coupon/:token/:lang"
              element={<DesktopCoupon />}
            />
            <Route
              path="/chat_widget/:theme=default/:feature=text-me/:token/:lang/:locationId?"
              element={<TextMeView theme="default" />}
            />
            <Route
              path="/chat_widget/:theme=light/:feature=text-me/:token/:lang/:locationId?"
              element={<TextMeView theme="light" />}
            />
            <Route path="/cta/:locationId/:lang" element={<CtaView />} />
            <Route path="/popup/:token/:lang" element={<Popup />} />
            <Route path="/mobile-cta/:token/:lang" element={<MobileCta />} />
            <Route
              path="/subscriber-growth/:token/:lang"
              element={<SubscriberGrowth />}
            />
            <Route
              path="/chat_widget/:theme=default/:token/:lang"
              element={
                <ChatProvider>
                  <ChatLayout theme="default" />
                </ChatProvider>
              }
            />
            <Route
              path="/wiz_widget/:theme=default/:token/:lang"
              element={
                <ChatProvider>
                  <WizLayout theme="default" />
                </ChatProvider>
              }
            />
            <Route
              path="/chat_widget/:theme=light/:token/:lang"
              element={
                <ChatProvider>
                  <ChatBox theme="light" />
                </ChatProvider>
              }
            />
            <Route path="/demo-inventory" element={<Inventory />} />
            <Route path="/demo-details" element={<Details />} />

            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Suspense>
      </Router>
    </ContextDataProvider>
  );
}

export default App;
